import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';

import * as pwResetActions from 'modules/pwReset';
import { LoginTemplate, CheckEmail, CheckEmailResult } from 'components';

import * as validFunc from 'libs/validation';

/* 비밀번호 재설정 컴포넌트 */
class CtPasswdReset extends Component {
  constructor(props) {
    super(props);

    this.handleChangeCE = this.handleChangeCE.bind(this);
    //this.handleKeyPressCE = this.handleKeyPressCE.bind(this);
    this.checkEmail = this.checkEmail.bind(this);
    this.reSendEmail = this.reSendEmail.bind(this);
    this.movePasswdReset = this.movePasswdReset.bind(this);
    this.handleChangePR = this.handleChangePR.bind(this);
    this.handleKeyPressPR = this.handleKeyPressPR.bind(this);
    this.putPasswdReset = this.putPasswdReset.bind(this);

    this.state = { errorMessage: '' };

    // 초기화
    const { PwResetActions } = this.props;
    PwResetActions.initPasswdReset();
  }

  // (CheckEmail) input에 값 입력 처리
  handleChangeCE = e => {
    const { PwResetActions } = this.props;
    const { name, value } = e.target;

    if (validFunc.email(value)) {
      this.setState({ errorMessage: validFunc.email(value) });
    } else {
      this.setState({ errorMessage: '' });
      PwResetActions.changeInput({
        name,
        value
      });
    }
  };

  // (CheckEmail) 엔터 처리
  // handleKeyPressCE = e => {
  //   if (e.key.toLowerCase() === 'enter') {
  //     this.checkEmail();
  //   }
  // };

  // (CheckEmail) 이메일 확인
  checkEmail = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { PwResetActions, form, isResend } = this.props;

    if (form.get('userEmail') !== '') {
      //await PwResetActions.postCheckEmail(form);
      await PwResetActions.getCheckPasswdEmail({ userEmail: form.get('userEmail') });
    }

    const { send } = this.props;

    if (send.get('isExist') === 2) {
      this.setState({
        errorMessage: defineMessages(formatMessage({ id: 'CheckEmail_5', defaultMessage: '존재하지 않는 계정입니다.' }))
      });
    } else {
      //
    }
  };

  // (CheckEmailResult) 메일 재전송
  reSendEmail = () => {
    // 재전송 했을 경우 메일 로직에 대한 동기처리가 필요함
    const { PwResetActions, form } = this.props;

    if (form.get('userEmail') !== '') {
      //PwResetActions.postCheckEmail(form);
      PwResetActions.getCheckPasswdEmail({ userEmail: form.get('userEmail') });
      PwResetActions.initPasswdResetMail();
    }
  };

  // (CheckEmailResult) 메일 전송에서의 확인 버튼(다음)
  movePasswdReset = () => {
    const { PwResetActions, send } = this.props;

    if (send.get('isSend') === 1) {
      // PwResetActions.movePasswdReset();

      // (단계 변경) 확인시 로그인 창으로 이동
      return this.props.history.push('/login');
    }
  };

  // (PasswdReset) input에 값 입력 처리
  handleChangePR = e => {
    const { PwResetActions } = this.props;
    const { name, value } = e.target;

    PwResetActions.changeInput({
      name,
      value
    });
  };

  // (PasswdReset) 엔터 처리
  handleKeyPressPR = e => {
    if (e.key === 'enter') {
      this.putPasswdReset();
    }
  };

  // (PasswdReset) 비밀번호 재설정
  putPasswdReset = () => {
    const { PwResetActions, form } = this.props;

    PwResetActions.putPasswdReset(form);
  };

  // (PasswdResetResult) 로그인 창으로 이동
  moveLogin = () => {
    // return <Redirect to='/login' />;
    return this.props.history.push('/login');
  };

  render() {
    const {
      handleChangeCE,
      handleKeyPressCE,
      handleChangePR,
      handleKeyPressPR,
      checkEmail,
      putPasswdReset,
      movePasswdReset,
      reSendEmail,
      moveLogin
    } = this;
    const { send, isReSend, reset, step, form } = this.props;
    return (
      <LoginTemplate>
        {step === 1 && (
          <CheckEmail
            send={send}
            handleChangeCE={handleChangeCE}
            handleKeyPressCE={handleKeyPressCE}
            checkEmail={checkEmail}
            errorMessage={this.state.errorMessage}
          />
        )}
        {step === 2 && (
          <CheckEmailResult
            isSend={send.get('isSend')}
            isReSend={isReSend}
            movePasswdReset={movePasswdReset}
            reSendEmail={reSendEmail}
          />
        )}
      </LoginTemplate>
    );
  }
}

CtPasswdReset.propTypes = {};
CtPasswdReset.defaultProps = {};

const mapStateToProps = state => ({
  send: state.pwReset.get('send'),
  isReSend: state.pwReset.get('isReSend'),
  reset: state.pwReset.get('reset'),
  step: state.pwReset.get('step'),
  form: state.pwReset.get('form')
});

const mapDispatchToProps = dispatch => ({
  PwResetActions: bindActionCreators(pwResetActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtPasswdReset));



// WEBPACK FOOTER //
// ./src/script/containers/login/CtPasswdReset.js